<template>
  <div>
    <h1>Nova de Area</h1>
    <b-card no-body class="border-0">
      <Form @saved="loadData" />
    </b-card>
  </div>
</template>

<script>
import Form from "../Components/Form.vue";
import { mapState, mapActions } from "vuex";

export default {
  components: { Form },
  computed: {
    ...mapState("areas", ["area"]),
  },
  methods: {
    ...mapActions("areas", ["ActionNewArea"]),
    loadData(id) {
      this.$router.push({ name: "areas_edit", params: { id: id } });
    },
  },
  async created() {
    this.ActionNewArea();
  },
};
</script>

<style></style>
